<p-dialog
    [visible]="visible"
    (visibleChange)="visibleChange.emit($event)"
    [modal]="true"
    [closable]="true"
    [draggable]="false"
    [resizable]="false"
    [dismissableMask]="true"
    styleClass="dialog-sm"
    [breakpoints]="{ '575px': '92vw' }"
    [header]="'cookie.preferencesTitle' | translate">
    <p class="cp-intro">{{ 'cookie.preferencesIntro' | translate }}</p>

    <!-- Essential first, and locked: stating plainly what cannot be switched off
         is part of the notice, not a UI afterthought. -->
    <div class="cp-row">
        <div class="cp-text">
            <span class="cp-name">{{ 'cookie.essentialTitle' | translate }}</span>
            <span class="cp-desc">{{ 'cookie.essentialDescription' | translate }}</span>
        </div>
        <p-tag class="cp-locked" [value]="'cookie.alwaysActive' | translate" severity="secondary" />
    </div>

    <div class="cp-row">
        <div class="cp-text">
            <label class="cp-name" for="cookie-analytics">{{ 'cookie.analyticsTitle' | translate }}</label>
            <span class="cp-desc">{{ 'cookie.analyticsDescription' | translate }}</span>
        </div>
        <p-toggleswitch
            inputId="cookie-analytics"
            [(ngModel)]="analytics"
            [ariaLabel]="'cookie.analyticsTitle' | translate"></p-toggleswitch>
    </div>

    <a class="cp-policy text-link" [href]="policyUrl" target="_blank">{{ 'cookie.link' | translate }}</a>

    <ng-template #footer>
        <p-button severity="secondary" [label]="'common.cancel_button' | translate" (onClick)="close()" />
        <p-button [label]="'cookie.save' | translate" (onClick)="save()" />
    </ng-template>
</p-dialog>
